import { Container } from "../../components";

export const LandingPeru = () => <Container header titulo="Acá se verá la obra de arte de Dante" />;
